import { DcddTotalUserProps } from "modules/report/dcdd_report/state/actionType"

export enum actionTypes {
    FETCH_COMMERCIAL_TOTAL_USER_REQUEST = 'FETCH_COMMERCIAL_TOTAL_USER_REQUEST',
    FETCH_COMMERCIAL_TOTAL_USER_SUCCESS = 'FETCH_COMMERCIAL_TOTAL_USER_SUCCESS',
    FETCH_COMMERCIAL_TOTAL_USER_FAIL = 'FETCH_COMMERCIAL_TOTAL_USER_FAIL',
    FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_REQUEST = 'FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_REQUEST',
    FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_SUCCESS = 'FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_SUCCESS',
    FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_FAIL = 'FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_FAIL',
    FETCH_FETCH_MEMBERSHIP_COUNT_REQUEST = 'FETCH_FETCH_MEMBERSHIP_COUNT_REQUEST',
    FETCH_FETCH_MEMBERSHIP_COUNT_SUCCESS = 'FETCH_FETCH_MEMBERSHIP_COUNT_SUCCESS',
    FETCH_FETCH_MEMBERSHIP_COUNT_FAIL = 'FETCH_FETCH_MEMBERSHIP_COUNT_FAIL',
    RESET_COMMERCIAL_FILTER_DATA = 'RESET_COMMERCIAL_FILTER_DATA'
}


export enum stateStatusType {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

export interface CommercialTotalUserProps{
    total_new:number
    total_all:number
    total_active:number
}
export interface MembershipCountProps{
    standard_user_count:number
    total_count:number
    basic_user_count:number
    premium_user_count:number
}
export interface CommercialTotalUserDataInput{
    from_date:string
    to_date:string
}

export interface FetchCommercialTotalUserRequestAction {
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_REQUEST;
}

export interface FetchCommercialTotalUserSuccessAction {
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_SUCCESS;
    payload: CommercialTotalUserProps;
}

export interface FetchCommercialTotalUserFailureAction {
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_FAIL;
    payload: string;
}
export interface FetchCommercialTotalUserByFilterRequestAction {
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_REQUEST;
}

export interface FetchCommercialTotalUserByFilterSuccessAction {
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_SUCCESS;
    payload: DcddTotalUserProps;
}

export interface FetchCommercialTotalUserByFilterFailureAction {
    type: actionTypes.FETCH_COMMERCIAL_TOTAL_USER_BY_FILTER_FAIL;
    payload: string;
}
export interface FetchMembershipCountRequestAction {
    type: actionTypes.FETCH_FETCH_MEMBERSHIP_COUNT_REQUEST
}

export interface FetchMembershipCountSuccessAction {
    type: actionTypes.FETCH_FETCH_MEMBERSHIP_COUNT_SUCCESS;
    payload: MembershipCountProps;
}

export interface FetchMembershipCountFailureAction {
    type: actionTypes.FETCH_FETCH_MEMBERSHIP_COUNT_FAIL;
    payload: string;
}
export interface ResetCommercialFilterDataAction {
    type: actionTypes.RESET_COMMERCIAL_FILTER_DATA;
}

export type CommercialDataReport = 
    | FetchCommercialTotalUserRequestAction
    | FetchCommercialTotalUserSuccessAction
    | FetchCommercialTotalUserFailureAction
    | FetchCommercialTotalUserByFilterRequestAction
    | FetchCommercialTotalUserByFilterSuccessAction
    | FetchCommercialTotalUserByFilterFailureAction
    | ResetCommercialFilterDataAction
    | FetchMembershipCountRequestAction
    | FetchMembershipCountSuccessAction
    | FetchMembershipCountFailureAction